(function () {
    'use strict';

    angular
        .module('app')
        .controller('sendto', sendto);

    sendto.$inject = ['$location', '$scope', '$rootScope', '$filter', '$q', 'sendtoservice', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'sendtoservice'];

    function sendto($location, $scope, $rootScope, $filter, $q, sendtoservice, $timeout, $mdDialog, records, command, commandService, loginService, sendToService) {
        $scope.loginService = loginService;
        $scope.processing = false;
        //list of steps
        $scope.steps = [{ id: 1, active: true, text: loginService.resourceStrings["SENDTO_SENDTYPE"] }, { id: 2, active: false, text: loginService.resourceStrings["SENDTO_OPTIONS"] }, { id: 3, active: false, text: loginService.resourceStrings["EDIT_EMAIL"] }];
        $scope.recipients = [];
        $scope.modeSelected = 1;

        //animation classes
        $scope.leaveAnimationClass = '';
        $scope.enterAnimationClass = '';
        $scope.complete = false;
        $scope.zipPassword = false;
        
        var listId = '';         //list id for notification list
        var bodyTemplate = '';   //system-generate message body (for als files)
        //generate the notification id then call the service to get the notification email message body
        sendtoservice.generateNotificationId().then(function (id) {
            listId = id;
            sendtoservice.getNotificationEmailBody(id).then(function (message) {
                bodyTemplate = message;
            });
        })

        $scope.attachmentFile = "";
        $scope.bodyTemplate = "";

        //model
        $scope.model = {
            sendToOptions: {
                alsFilename: "AdeptList.als",
                zipFilename: "AdeptList.zip",
                sendAlsLink: true,
                includeChildren: false,
                sendDocuments: false,
                excludeFilteredLibs: false,
                zipFiles: false,
                zipPassword: "",
                listId: "",
            },
            selectionListMaster: [
            ],
            selectionList: commandService.records,
            emailModel: {
                emailSubject: "",
                emailBody: "",
                emailRecipients: []
            }
        }

        //event listeners
        $scope.onOk = function () {
            $mdDialog.hide();
        }

        $scope.onCancel = function () {
            $mdDialog.hide();
        }

        $scope.modeChanged = function (selected) {
            if (selected == 1) {
                $scope.model.sendToOptions.sendAlsLink = true;
                $scope.model.sendToOptions.sendDocuments = false;
            }
            else if (selected == 2) {
                //defect id: 24543
                //someone removed these settings from here (selected == 2) and didn't test
                //these settings need to be here for the document options - including zip - to be options on the interface
                $scope.model.sendToOptions.sendDocuments = true;
                $scope.model.sendToOptions.sendAlsLink = false;
            }
            else {
                $scope.model.sendToOptions.sendDocuments = true;
                $scope.model.sendToOptions.sendAlsLink = false;
            }
        }

        $scope.nextStep = function (step) {
            $scope.bodyTemplate = $scope.model.sendToOptions.sendAlsLink ? bodyTemplate : "";
            $scope.leaveAnimationClass = 'option-area-leave-left';
            $scope.enterAnimationClass = 'option-area-enter-right';
            $scope.transition = true;
            $scope.steps[step - 1].active = false;
            $scope.steps[step].active = true;
        }

        $scope.gotoStep = function (step) {
            $scope.bodyTemplate = $scope.model.sendToOptions.sendAlsLink ? bodyTemplate : "";
            var active = $filter('filter')($scope.steps, { active: true })[0];
            if (step > active.id - 1) {
                $scope.leaveAnimationClass = 'option-area-leave-left';
                $scope.enterAnimationClass = 'option-area-enter-right';
            }
            else {
                $scope.leaveAnimationClass = 'option-area-leave-right';
                $scope.enterAnimationClass = 'option-area-enter-left';
            }

            angular.forEach($scope.steps, function (item) {
                item.active = false;
            });
            $scope.steps[step].active = true;
        }

        $scope.send = function () {
            $scope.model.sendToOptions.listId = listId;
            var htmlEl = $($scope.model.emailBody);
            //assign user-provided message body to variable
            var text = $scope.model.emailModel.emailBody;
            //add the system-defined message body (used for als attachments)
            text = text + $scope.bodyTemplate;
            text = text.replace(/<div>/g, "\r");
            text = text.replace(/<\/div>/g, "");
            text = text.replace(/<br>/g, "\r");
            $scope.model.emailModel.emailBody = text;
            $scope.processing = true;
            angular.forEach($scope.recipients, function (item) {
                $scope.model.emailModel.emailRecipients.push(item.EmailAddress);
            });

            console.log($scope.model);
            sendToService.sendto($scope.model).then(function (response) {
                $scope.processing = false;
                $scope.complete = true;

                // 2018-04-16
                var sendToResult = response.data;
                if (sendToResult.bSent == false || sendToResult.message.length > 0 || sendToResult.list.length > 0)
                {
                    var slx = sendToResult.slx;

                    // Make it stand out more that the message was not sent.
                    var errStr = sendToResult.message;
                    if (sendToResult.bSent == false)
                        errStr = "***** " + sendToResult.message + " *****";

                    slx.list.unshift({ errStr: errStr });
                    commandService.launchErrors({ slx: slx });
                }
            }, function (rejection) {
                $scope.processing = false;
            })
        }

        $scope.zipOptionChanged = function () {
            $scope.model.sendToOptions.zipPassword = "";
        }
        activate();
        function activate() {
            sendtoservice.getNotificationEmailSubject($scope.model.selectionList).then(function (subject) {
                $scope.model.emailModel.emailSubject = subject;
            });
        }
    }
})();
